import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/theme.css'
import './styles/responsive.css'
import * as echarts from 'echarts'
import VueECharts from 'vue-echarts'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.component('v-chart', VueECharts)

echarts.registerTheme('dark-finance', {
  backgroundColor: 'transparent',
  textStyle: { color: '#94a3b8' },
  title: { textStyle: { color: '#e2e8f0' } },
  legend: { textStyle: { color: '#94a3b8' } },
  tooltip: { backgroundColor: '#1a1d27', borderColor: '#363944', textStyle: { color: '#e2e8f0' } },
  categoryAxis: { axisLine: { lineStyle: { color: '#363944' } }, axisTick: { lineStyle: { color: '#363944' } }, axisLabel: { color: '#64748b' }, splitLine: { lineStyle: { color: '#242730' } } },
  valueAxis: { axisLine: { lineStyle: { color: '#363944' } }, axisTick: { lineStyle: { color: '#363944' } }, axisLabel: { color: '#64748b' }, splitLine: { lineStyle: { color: '#242730' } }, nameTextStyle: { color: '#64748b' } }
})

app.config.globalProperties.$echarts = echarts

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')
